import { render } from "./WardsAndBeds.vue?vue&type=template&id=74eea230&scoped=true"
import script from "./WardsAndBeds.vue?vue&type=script&lang=js"
export * from "./WardsAndBeds.vue?vue&type=script&lang=js"

import "./WardsAndBeds.vue?vue&type=style&index=0&id=74eea230&lang=css"
import "./WardsAndBeds.vue?vue&type=style&index=1&id=74eea230&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74eea230"]])

export default __exports__